if(typeof nodemailer === 'undefined') { var e = new Error("Cannot find module 'nodemailer'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = nodemailer;